// Production rates from ICPAK Binder Terms (May 2026).
// `version` must be bumped on every change for audit.
export const motorRatesData = {
    product: "motor_private",
    version: "1.0.1",
    comprehensive: {
        valueBands: [
            { maxValueKes: 1500000, ratePct: 0.04 },
            { maxValueKes: 2500000, ratePct: 0.0375 },
            { maxValueKes: 2999999, ratePct: 0.035 },
            { maxValueKes: Infinity, ratePct: 0.03 },
        ],
        minimumBasicPremiumKes: 42500,
        extensionsIncludedInBasic: [
            "EXCESS_PROTECTOR",
            "POLITICAL_VIOLENCE_TERRORISM",
        ],
        extensionFlatFeesKes: {
            AA_ROAD_RESCUE: 6500,
            PERSONAL_ACCIDENT: 5000,
            COURTESY_CAR_10_DAYS: 3000,
        },
    },
    thirdParty: { flatPremiumKes: 10000 },
    levies: { trainingLevyPct: 0.002, policyHolderFundPct: 0.0025 },
    stampDutyKes: 40,
};
